import { Component, Input, OnInit } from '@angular/core';

import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-composition-wizard-summary',
    templateUrl: './composition-wizard-summary.component.html',
    styleUrls: ['./composition-wizard-summary.component.scss'],
    standalone: false
})
export class CompositionWizardSummaryComponent implements OnInit {

  public availableLanguages = {
    de: {
      title: 'German'
    },
    en: {
      title: 'English'
    },
    fr: {
      title: 'French'
    },
    it: {
      title: 'Italian'
    }
  };

  @Input() composition: Models.Composition;

  constructor() {
  }

  ngOnInit() {
  }

}
